import axiosClient from ".";

class UserFeedbacks {
  static getUserFeedbacks(page) {
    return axiosClient.get(`/super_admin/api/user_messages.json?page=${page}`);
  }
}
export default UserFeedbacks;
